<!-- This example requires Tailwind CSS v2.0+ -->
<template>
  <div class="">
    <!-- Products -->
    <div
      v-if="brandService.getName() === Brand.HIS"
      class="lg:space-y-0 lg:flex lg:flex-wrap lg:justify-center lg:gap-4 lg:max-w-full"
    >
      <HispPlanSelectorProduct
        v-for="product in products"
        @onPlanSelected="(id) => emit('onPlanSelected', id)"
        :canSelectProduct="canSelectProduct"
        :product="product"
        :key="product.name"
        :isSelectedProduct="isSelectedProduct(product)"
        :planSelectorProductInformation="planSelectorProductInformation"
      />
    </div>
    <div
      v-else
      class="lg:space-y-0 lg:flex lg:flex-wrap lg:justify-center lg:gap-4 lg:max-w-full"
    >
      <PlanSelectorProduct
        v-for="product in products"
        @onPlanSelected="(id) => emit('onPlanSelected', id)"
        :canSelectProduct="canSelectProduct"
        :product="product"
        :key="product.name"
        :isSelectedProduct="isSelectedProduct(product)"
        :planSelectorProductInformation="planSelectorProductInformation"
      />
    </div>
  </div>
</template>

<script setup lang='ts'>
import PlanSelectorProduct from './PlanSelectorProduct.vue';
import HispPlanSelectorProduct from './HispPlanSelectorProduct.vue';
import { defineProps, defineEmits, computed } from 'vue';
import { injectStrict } from '@/plugins/vueServiceContainerPlugin';
import { BrandServiceInterface } from '@/services/brand/brandServiceInterface';
import store from '@/store';
import { Brand } from '../../services/integration/enums';

const brandService = injectStrict<BrandServiceInterface>('BrandServiceInterface');

// Computed properties.
const serviceQualification = computed(() => {
  // Get SQ from store.
  return store.state.serviceQualification;
});

const planSelectorProductInformation = brandService.getPlanSelectorProductInformation(serviceQualification.value?.carrier);

type Product = {
  id: string,
  name: string,
  description: string,
  download: number | null,
  upload: number | null,
  typicalEveningSpeed: number | null,
  price: number
}

const props = defineProps<{
  canSelectProduct: boolean,
  products: Array<Product>,
  selected: string
}>();

const emit = defineEmits<{(e: 'onPlanSelected', id: string): void}>();

const isSelectedProduct = (product: Product): boolean => {
  return props.canSelectProduct && product.id === props.selected;
};
</script>
